import React, { Fragment } from 'react'
import { string, shape, func, bool } from 'prop-types'

import SvgIcon from '../SvgIcon/SvgIcon'
import appRoutes from '../../configuration/appRoutes'
import { formVariants } from '../LoginModal/constants'
import ConfigConsumer from '../../redux/configuration/context'

const HeaderProfileToggles = ({
  ferryLabels,
  handleRouteChange,
  openModal,
  agentProfile,
  isLoggedIn,
  activeUserName,
  onLogout,
  loginButtonLabel,
  showManageReservations,
  notShowIcon
}) => {
  const modalType = agentProfile
    ? showManageReservations
      ? formVariants.TRAVEL_AGENT_LOGIN
      : formVariants.COMMERCIAL_AGENT_LOGIN
    : formVariants.CUSTOMER_LOGIN

  return (
    <div className="">
      <span className="header-toggle header__content-item">
        {notShowIcon || (agentProfile && !isLoggedIn) ? null : (
          <button
            onClick={() => {
              if (!isLoggedIn) {
                openModal({ type: modalType })
              } else {
                handleRouteChange(appRoutes.account.pathname)
              }
            }}
            className="header-icon-button"
          >
            <ConfigConsumer>
              {({ themeVariables }) => (
                <SvgIcon
                  className="header__profile-icon"
                  type="profile"
                  fill={themeVariables.themeHeaderIconColor}
                />
              )}
            </ConfigConsumer>
          </button>
        )}

        {!isLoggedIn && agentProfile && showManageReservations && (
          <button
            onClick={() => handleRouteChange(appRoutes.modifyBooking.pathname)}
            className="header-toggle__button profile-manage"
          >
            {ferryLabels.manageReservations || 'Manage Reservations'}
          </button>
        )}

        {isLoggedIn ? (
          !notShowIcon ? (
            <Fragment>
              <button
                onClick={() => {
                  handleRouteChange(appRoutes.account.pathname)
                }}
                className="header-toggle__button profile-login"
              >
                {activeUserName}
              </button>
              <button
                onClick={onLogout}
                className="header-toggle__button profile-register"
              >
                {ferryLabels.logout}
              </button>
            </Fragment>
          ) : null
        ) : (
          <Fragment>
            <button
              onClick={() => {
                openModal({ type: modalType })
              }}
              className="header-toggle__button profile-login"
            >
              {loginButtonLabel}
            </button>
            {!agentProfile && (
              <Fragment>
                <button
                  onClick={() => handleRouteChange(appRoutes.register.pathname)}
                  className="header-toggle__button profile-register"
                >
                  {ferryLabels.register}
                </button>
              </Fragment>
            )}
          </Fragment>
        )}
      </span>
    </div>
  )
}

HeaderProfileToggles.propTypes = {
  ferryLabels: shape().isRequired,
  handleRouteChange: func.isRequired,
  openModal: func.isRequired,
  agentProfile: bool,
  isLoggedIn: bool,
  activeUserName: string,
  onLogout: func.isRequired,
  loginButtonLabel: string,
  showManageReservations: bool,
  notShowIcon: bool
}

HeaderProfileToggles.defaultProps = {
  agentProfile: false,
  isLoggedIn: false,
  activeUserName: '',
  loginButtonLabel: '',
  showManageReservations: false,
  notShowIcon: false
}

export default HeaderProfileToggles
